<template>
  <div>
    <div v-show="!userEmail" class="sollae-preloader"></div>
    <page-layout v-show="userEmail" />
    <div
      v-show="userEmail"
      :class="[
        'children-content',
        {
          'non-fixed-position': isExpanding,
          'float-over': isStudio && !isExpanding,
        },
      ]"
    >
      <router-view @fetch-api="init" />
    </div>
    <common-modal />
    <common-toast />
    <common-footer />
    <progress-bar />
    <alarm-sound v-if="!isMobile" />
    <device-setting-menu v-if="showSettingMenu" />
  </div>
</template>
<script>
import '@/assets/css/phpoc-common.css';
import apiMixin from '@/mixins/apiMixin';
import { EventBus } from '@/js/utils';
import { removeLoader } from '@/js/staticUtils';
import PageLayout from '@/components/layout/PageLayout';
import ErrorComponent from '@/components/common/AsyncError';

const DeviceSettingMenu = () => ({
  component: import('@/components/device/DeviceSettingMenu'),
  // loading: LoadingComponent,
  error: ErrorComponent,
  // delay: 200,
  timeout: 5000,
});

export default {
  name: 'UserPage',
  components: {
    PageLayout,
    DeviceSettingMenu,
  },
  mixins: [apiMixin],
  computed: {
    showSettingMenu() {
      return this.$store.getters['ports/settingView'];
    },
    isExpanding() {
      return this.$route.meta.fullScreen;
    },
    isStudio() {
      return /studio/.test(this.$route.fullPath);
    },
    userEmail() {
      return this.$store.getters['user/userEmail'];
    },
  },
  methods: {
    // setLocalLang() {
    // this.$store.dispatch('local/getLanguage')
    // .then(() => this.$store.getters['local/language'])
    // .then(lang => { this.$i18n.locale = lang })
    // .catch(err => console.error(err.message))
    // },
    init(params) {
      this.initUserDeviceList(params);
    },
    updateSize() {
      this.$store.dispatch('local/setWrapperSize', new Date().getTime());
    },
  },
  created() {
    // this.setLocalLang();
    this.$store.dispatch('local/getSortby');
    // EventBus.$on('fetch-port-group', this.getPortGroupDataAPI);
    EventBus.$on('fetch-ports', this.getPortsDataAPI);
    // EventBus.$on('retrieve-all', this.initFullData);
    // EventBus.$on('retrieve-port-group', this.retrievePortGroupDataAPI);
    // EventBus.$on('retrieve-ports', this.retrievePortsDataAPI);
    EventBus.$on('fetch-device', this.getIncreasedDeviceList);
    EventBus.$on('remove-device', this.getDecreasedDeviceList);
    EventBus.$on('fetch-firmware', this.getPkgwareInfo);
    EventBus.$on('fetch-log-download', this.retrieveLogDownloadLink);
    EventBus.$on('fetch-log-data', this.retrieveLogData);
    EventBus.$on('set-userinfo', this.updateUserInfo);
    EventBus.$on('retrieve-devicelist', this.retrieveDeviceListAPI);

    // EventBus.$on('get-modbus-slave', this.getModbusSlaveSetting)
    EventBus.$on('update-device-setting', this.updateDeviceSetting);
    EventBus.$on('update-modbus-setting', this.updateModbusSetting);
    EventBus.$on('add-modbus-slave', this.addModbusSlave);
    EventBus.$on('edit-modbus-slave', this.editModbusSlave);
    EventBus.$on('remove-modbus-slave', this.removeModbusSlave);
    // EventBus.$on('update-devicelist', this.getLatestDeviceList);
    window.onresize = this.updateSize;
    removeLoader();
  },
  beforeDestroy() {
    // EventBus.$off('fetch-port-group');
    EventBus.$off('fetch-ports');
    EventBus.$off('fetch-device');
    // EventBus.$off('retrieve-all');
    // EventBus.$off('retrieve-port-group');
    // EventBus.$off('retrieve-ports');
    EventBus.$off('remove-device');
    EventBus.$off('fetch-firmware');
    EventBus.$off('set-userinfo');
    EventBus.$off('retrieve-devicelist');
    // EventBus.$off('update-devicelist');
    EventBus.$off('fetch-log-download');
    EventBus.$off('fetch-log-data');

    // EventBus.$off('get-modbus-slave')
    EventBus.$off('update-device-setting');
    EventBus.$off('update-modbus-setting');
    EventBus.$off('add-modbus-slave');
    EventBus.$off('edit-modbus-slave');
    EventBus.$off('remove-modbus-slave');

    window.onresize = null;
    // EventBus.$off('fetch-device', this.getIncreasedDeviceList);
    // EventBus.$off('remove-device', this.getDecreasedDeviceList);
    // EventBus.$off('fetch-firmware', this.getPkgwareInfo);
  },
  // watch:{
  //  $route (to, from) {
  //    this.$progressBar.show();
  //  }
  // }
};
</script>
